import React from "react";
import PropTypes from "prop-types";
import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined";
import { cn } from "../cn";
import styles from "./Collapse.module.scss";

/**
 * Collapse — a controlled multi-open accordion. Replaces antd Collapse/Panel.
 *
 * items:      [{ key, header, content }]
 * activeKeys: array of open item keys (controlled)
 * onChange:   (nextActiveKeys) => void
 */
export function Collapse({ items = [], activeKeys = [], onChange, className }) {
  const isOpen = (key) => activeKeys.includes(key);

  const toggle = (key) => {
    if (!onChange) return;
    onChange(
      isOpen(key) ? activeKeys.filter((k) => k !== key) : [...activeKeys, key]
    );
  };

  return (
    <div className={cn(styles.collapse, className)}>
      {items.map((item) => {
        const open = isOpen(item.key);
        return (
          <div key={item.key} className={styles.panel}>
            <button
              type="button"
              className={styles.header}
              aria-expanded={open}
              onClick={() => toggle(item.key)}
            >
              <KeyboardArrowDownOutlined
                className={cn(styles.chevron, open && styles.chevronOpen)}
                fontSize="small"
              />
              <span className={styles.headerText}>{item.header}</span>
            </button>
            {open ? <div className={styles.body}>{item.content}</div> : null}
          </div>
        );
      })}
    </div>
  );
}

Collapse.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      header: PropTypes.node,
      content: PropTypes.node,
    })
  ),
  activeKeys: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Collapse;
